import React from 'react';
import PropTypes from 'prop-types';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import SaveIcon from '@material-ui/icons/Save';
import TextField from '@material-ui/core/TextField';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { FormControl, Grid, InputLabel } from '@material-ui/core';
import { Delete } from '@material-ui/icons';
import { reformatDateYYYYmmDD } from 'routes/Pages/FichasTecnicas/ConstsAndUtils/utils';
import { TEXT_COLOR_FT } from 'config/config';

const EditableRow = ({ row, headCells, isEditing, isEditable, onInputChange, onSave, onEdit,
    tiposAux, autoridadesAux, estadosAux, garantia, onDelete
}) => {

    const optionsReturn = (arr) => {
        return arr.map((item, index) => {
            return <MenuItem key={index} value={item.label}> {item.label}</MenuItem>
        })
    }

    const getOptions = (campo) => {

        switch (campo) {
            case 'id_tipo_servicio': const auxArrTipos = tiposAux.slice(1)
                return optionsReturn(auxArrTipos)
            case 'id_edo_aut_sanitaria': const auxArrEstados = estadosAux.slice(1)
                return optionsReturn(auxArrEstados)
            case 'id_autoridad': const auxAutoridadesArr = autoridadesAux.slice(1)
                return optionsReturn(auxAutoridadesArr)
            case 'garantia_vigente': const auxGarantiaArr = garantia.slice(1)
                return optionsReturn(auxGarantiaArr)
            default: return optionsReturn(tiposAux)
        }

    }

    const validateEmptyField = (str) => {
        if (str) {
            return true
        } else {
            return false
        }
    }

    const validateForm = () => {

        const fieldsToValidate = headCells.filter(field => {
            return row[field.id] === ''
        });

        return !fieldsToValidate.every(field => headCells[field] === true);

    }

    const dateData = (data) => {

        if (data) {
            return reformatDateYYYYmmDD(data)
        } else {
            return ''
        }


    }

    const renderCellContent = (headCell) => {
        if (isEditing) {
            switch (headCell.type) {

                case 'text':
                    return (
                        <TextField
                            size='small'
                            error={!validateEmptyField(row[headCell.id])}
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => onInputChange(e, headCell.id, headCell.type)}
                            disabled={headCell.id === "nombre" ? true : false}
                        />
                    );
                case 'number':
                    return (
                        <TextField
                            size='small'
                            error={!validateEmptyField(row[headCell.id])}
                            variant='outlined'
                            value={row[headCell.id] || ''}
                            onChange={(e) => {

                                if (/^\d*$/.test(e.target.value)) {
                                    onInputChange(e, headCell.id, headCell.type)
                                }
                            }
                            }
                            disabled={headCell.id === "nombre" ? true : false}
                        />
                    );
                case 'select':
                    return (
                        <FormControl size='small' fullWidth>
                            <InputLabel htmlFor="grouped-native-select" style={{ marginTop: -7, marginLeft: 15, fontSize: 14 }}>
                                {row[headCell.label] || ''}
                            </InputLabel>
                            <Select
                                variant='outlined'
                                value={row[headCell.id] || ''}
                                onChange={(e) => onInputChange(e, headCell.id)}
                            >
                                {getOptions(headCell.id)}
                            </Select>
                        </FormControl>
                    );
                case 'date':
                    return (
                        <TextField
                            error={!validateEmptyField(row[headCell.id])}
                            size='small'
                            type="date"
                            variant='outlined'
                            value={dateData(row[headCell.id]) || ''}
                            onChange={(e) => onInputChange(e, headCell.id)}
                        />
                    );
                default:
                    return row[headCell.id];
            }
        }
        if (headCell.id === 'nombre' && row['otro_nombre']) {
            return row['otro_nombre']
        } else {
            return row[headCell.id];
        }

    };

    return (
        <TableRow>
            {headCells.map((headCell) => {
                if (headCell.shown) {
                    return (
                        <TableCell key={headCell.id} align={headCell.align || 'left'}
                            style={{ color: TEXT_COLOR_FT, paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 10 }}
                            >
                            {renderCellContent(headCell)}
                        </TableCell>
                    )
                } else {
                    return null
                }
            })}
            <TableCell align="center" style={{ color: TEXT_COLOR_FT, paddingTop: 0, paddingBottom: 0, paddingLeft: 10, paddingRight: 10 }}>
                {isEditing ? (<Grid container style={{ flexWrap: 'nowrap' }}>
                    <IconButton onClick={onSave} style={{ color: validateForm() ? 'gray' : 'green' }} disabled={validateForm()}>
                        <SaveIcon />
                    </IconButton>
                    <IconButton onClick={onDelete} style={{ color: 'red' }}>
                        <Delete />
                    </IconButton>
                </Grid>

                ) : (
                    <Grid container style={{ flexWrap: 'nowrap' }}>
                        <IconButton onClick={onEdit} disabled={!isEditable} style={{ color: !isEditable ? 'gray' : 'green' }}>
                            <EditIcon />
                        </IconButton>
                        <IconButton onClick={onDelete} style={{ color: 'red' }}>
                            <Delete />
                        </IconButton>
                    </Grid>
                )}
            </TableCell>
        </TableRow>
    );
};

EditableRow.propTypes = {
    row: PropTypes.object.isRequired,
    headCells: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
            align: PropTypes.oneOf(['left', 'right', 'center', 'justify']),
        })
    ).isRequired,
    isEditing: PropTypes.bool.isRequired,
    isEditable: PropTypes.bool.isRequired,
    onInputChange: PropTypes.func.isRequired,
    onSave: PropTypes.func.isRequired,
    onEdit: PropTypes.func.isRequired,
};

export default EditableRow;
